<template>
  <div class="input-text-size">
    <v-row>
      <v-col cols="6">
        <v-textarea
        outlined
        label="Audit Summary:"
        readonly
        :value="editedItem.auditSummary"
        >
        </v-textarea>
        <v-textarea
          outlined
          :rules="required"
          label="Reason:"
          v-model="editedItem.auditReason"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        >
        </v-textarea>
      </v-col>
      <v-col cols="6">
        <v-row dense>
          <v-col cols="12">
            <span><strong>Payment Entry Information:</strong></span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Business Date:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              v-model="editedItem.businessdate"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Payment #:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              v-model="editedItem.paymentNumberAudit"
              ></v-text-field>
            </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Receipt #:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              v-model="editedItem.reciept" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Wkst #:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              v-model="editedItem.workstation"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Users:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              v-model="editedItem.user"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <v-checkbox
            :disabled="isApprovalDisabled"
              v-model="editedItem.approvalStatus"
              label="Approved"
            ></v-checkbox>
            <span v-if="canApprove && cannotApproveOwnAudit" class="red--text input-text-size">
              You cannot approve your own audit record.
            </span>
            <span v-else-if="!canApprove" class="red--text input-text-size">
              Only Payments Administrators can approve audits.
            </span>
          </v-col>
        </v-row>
        <v-row  dense v-if="editedItem.approvalStatus">
          <v-col cols="6">
            <span>Approval Information:</span>
          </v-col>
        </v-row>
        <v-row  dense v-if="editedItem.approvalStatus">
          <v-col cols="3">
            <span>Date:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              :value="this.todaysDate"
              v-model="editedItem.approvalDate"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense v-if="editedItem.approvalStatus">
          <v-col cols="3">
            <span>Time:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              hide-details
              v-model="editedItem.approvalTime"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense v-if="editedItem.approvalStatus">
          <v-col cols="3">
            <span>User:</span>
          </v-col>
          <v-col cols="4 ">
            <v-text-field
              class="mt-n2 ml-n4"
              readonly
              dense
              v-model="editedItem.approvalUser"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapMutations,
  mapGetters,
  mapState,
} from 'vuex';
import '../../../../assets/style.css';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { toCentralTime } from '../../../../util/shared/vue-global';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      time: '',
    };
  },
  props: {
    canApprove: {
      type: Boolean,
      default: false,
    },
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters('auth/token', [
      'authUser',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    required() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    cannotApproveOwnAudit() {
      return !!this.paymentSettingItem.cannotApproveOwnAudit
        && this.editedItem.user === this.authUser;
    },
    isApprovalDisabled() {
      return !this.canApprove || this.cannotApproveOwnAudit;
    },
    editedItem: {
      // eslint-disable-next-line vue/return-in-computed-property, consistent-return
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  watch: {
    'editedItem.approvalStatus': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.time = this.getCurrentTime();
          this.editedItem.approvalDate = this.todaysDate;
          this.editedItem.approvalTime = this.time;
          this.editedItem.approvalStatus = true;
          this.editedItem.approvalUser = this.authUser;
        } else {
          this.editedItem.approvalStatus = false;
        }
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible', 'setItem',
    ]),
    getCurrentTime() {
      return toCentralTime(new Date());
    },
  },
};
</script>

<style scoped>
.text-underline {
  text-decoration: underline;
}

</style>
